import { ActionTree } from "vuex";
import { UserState, User } from "./model";
import { RootStateType } from "@/store";
import { AxiosResponse } from "axios";

const actions: ActionTree<UserState, RootStateType> = {
  findList({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].get('/users', {params: params})
      .then((response: AxiosResponse) => {
        const users: User[] = response.data;
        commit('setUsers', users)
        return users
      })
  },
  create({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].post('/users', params)
      .then((response: AxiosResponse) => {
        const user: User = response.data;
        commit('addUser', user)
        return user
      })
  },
  update({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].patch(`/users/${params.id}`, params)
      .then((response: AxiosResponse) => {
        const user: User = response.data;
        commit(('updateUser'), user)
        return user
      })
  },
  delete({ rootGetters, commit }, id) {
    return rootGetters['hcs/client'].delete(`/users/${id}`)
      .then((response: AxiosResponse) => {
        commit(('deleteUser'), id)
      })
  },
}

export default actions;
